import { apiInstance } from "api/config/axios";
import { getApiResponseData } from "./api-service";
import { IApiResponse } from "api/models/IApiResponse";
import { IAddWorkspaceRequest } from "api/models/request/IAddWorkspaceRequest";
import { IEditWorkspaceRequest } from "api/models/request/IEditWorkspaceRequest";
import { ISwitchWorkspaceRequest } from "api/models/request/ISwitchWorkspaceRequest";

const workspaceApiBaseUrl = '/workspace';

export const getCurrentWorkspaceInfo = (): Promise<IApiResponse<any>> => {
    return apiInstance.get(`${workspaceApiBaseUrl}/current`).then((response) => {
        return getApiResponseData(response);
    });
}
export const addWorkspace = (request: IAddWorkspaceRequest): Promise<IApiResponse<string>> => {
    return apiInstance.post(workspaceApiBaseUrl, request).then((response) => {
        return getApiResponseData(response);
    });
};

export const editWorkspaceName = (request: IEditWorkspaceRequest & { workspaceId: string }): Promise<IApiResponse<any>> => {
    return apiInstance.patch(`${workspaceApiBaseUrl}/${request.workspaceId}/name`, { name: request.name }).then((response) => {
        return getApiResponseData(response);
    });
};

export const switchWorkspace = (request: ISwitchWorkspaceRequest & { workspaceId: string }): Promise<IApiResponse<any>> => {
    return apiInstance.patch(`${workspaceApiBaseUrl}/switch`, { workspaceId: request.workspaceId }).then((response) => {
        return getApiResponseData(response);
    });
};

export const patchWorkspaceMfa = (request: { mfaEnabled: boolean } & { workspaceId: string; }): Promise<IApiResponse<any>> => {
    return apiInstance.patch(`${workspaceApiBaseUrl}/${request.workspaceId}/mfa`, { mfaEnabled: request.mfaEnabled }).then((response) => {
        return getApiResponseData(response);
    });
}

export const deleteWorkspace = (request: { workspaceId: string }): Promise<IApiResponse<any>> => {
    return apiInstance.delete(`${workspaceApiBaseUrl}/${request.workspaceId}`).then((response) => {
        return getApiResponseData(response);
    });
};